<!--费率列表 findRateList-->
<template>
  <div class="myhistoryValue">
    <div class="con">
      <div class="right-table">
        <div class="Files-top" style="display: flex;align-items: center;">
          <div class="ic-left">
            <span>费率列表</span>
          </div>
          <div class="btns">
            <el-button @click="add_ed" type="primary" class="last-el-button">新增</el-button>
          </div>
        </div>
        <div class="search-input-btn" style="width:100%">
          <div class="input-small">
            <span>单位名称：</span>
            <el-input v-model="listData.rateName" clearable placeholder="请输入单位名称"></el-input>
          </div>
          <div class="input-small">
            <span>状态：</span>
            <el-select v-model="listData.status" placeholder="请选择">
              <el-option label="全部" value=""> </el-option>
              <el-option label="启用" value="ENABLE"> </el-option>
              <el-option label="禁用" value="DISABLE"> </el-option>
            </el-select>
          </div>
          <el-button type="primary" plain @click="getList" class="search-btn">查询</el-button>
        </div>
        <div class="mytable" id="region-cost">
          <el-table :data="dataList" :height="heights" border style="width: 100%;">
            <el-table-column label="序号" width="50" align="center">
              <template slot="empty">
                <span class="noData">
                  <img src="../../../assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="rateName" label="费率名称" />
            <el-table-column prop="rateValue" label="费率值" />
            <!-- <el-table-column prop="createUser" label="创建人" /> -->
            <el-table-column prop="createTime" label="创建时间" />
            <el-table-column label="状态">
              <template #default="{row}">
                <el-switch v-model="row.dataStatus" active-value="ENABLE" inactive-value="DISABLE" active-text="启用"
                  inactive-text="禁用" @change="dataStatus_fn(row)">
                </el-switch>
              </template>
            </el-table-column>

          </el-table>

        </div>
      </div>
      <!-- 新增修改 -->
      <el-dialog :title="textMap[dialogStatus]" :close-on-click-modal='false' v-dialogDrag :visible.sync="dialogVisible"
        center width="700px">
        <div class="mydialog">
          <el-form :model="temp" :rules="rules" ref="temp" label-width="150px">
            <el-form-item label="费率名称:" prop="name">
              <el-input v-model="temp.rateName"></el-input>
            </el-form-item>
            <el-form-item label="费率值:" prop="rateValue">
              <el-input v-model="temp.rateValue"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="add_fn('temp')">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>

    </div>
  </div>
</template>

<script type="text/javascript">
  import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import request from "@/api/http.js";
  import Pagination from "@/components/module/Pagination"; // 分页
  import elIconBtn from '@/components/module/iconBtns.vue'
  import {parseTime} from '@/utils/index';
  export default {
    components: {
      elUnitTree,
      downloadTable,
      elIconBtn,
      Pagination
    },
    data () {
      return {
        listData: {
          rateName: "",
          status: ''
        },
        total: 10,
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()<Date.now();
          },
        },
        dialogVisible3: false,
        dataList2: [],
        temp: {},
        dialogStatus: '',
        dialogVisible: false,
        heights: document.getElementById('app').clientHeight-290,
        dataList: [{
          rateName: '运维',
          rateValue: '23',
          createTime: '2020-02-11',
        }],
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        rules: {
          rateName: [
            {required: true,message: '请输入费率名称',trigger: 'blur'}
          ],
          month: [
            {required: true,message: '请选择年月',trigger: 'change'}
          ],
          rateValue: [
            {required: true,message: '请输入费率值',trigger: 'blur'}
          ],
        },
        temped: {},
        unitName: ""
      }
    },
    watch: {
      dialogVisible: function(val) {
        // console.log(val);
        if(!val) {
          this.temp={}
        }
      },
      nowUnit () {
        this.unitName=this.nowUnit.name
        this.getList();
      }
    },
    mounted () {
      this.unitName=this.nowUnit.name
      this.getList();
    },
    computed: {
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
    },

    methods: {
      dataStatus_fn (v) {
        var params={
          dateStatus: v.dataStatus,
          id: v.id
        };

        request({url: "/meterReadingRates/enableOrDisableById",method: "put",params}).then(res => {
          console.log(res);
          if(res.code==200) {
            this.$message({showClose: true,message: '修改成功',type: 'success'});
          }
        })
      },

      getList () {
        var params=this.listData;
        request({url: "/meterReadingRates/findRateList",method: "get",params}).then(res => {
          if(res.code==200) {
            this.dataList=res.data;
            this.dataList.map(v => {
              if(v.createTime) {
                v.createTime=parseTime(v.createTime,'{y}-{m}-{d} {h}:{i}:{s}')
              }
              if(v.updateTime) {
                v.updateTime=parseTime(v.updateTime,'{y}-{m}-{d} {h}:{i}:{s}')
              }
            })
          }
        })
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            var data=this.temp
            request({url: "/meterReadingRates/saveRates",method: "post",data}).then(data => {
              if(data.code==200) {
                this.temp={}
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
                this.getList()

              } else {
                this.$message.error(`添加失败，${data.message}`);
              }
            })
          } else {
            return false;
          }
        });
      },

      // 添加弹窗
      add_ed () {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.temp={}
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
      },
      // 确认编辑
      edit_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            this.temp.pkId=this.temped.pkid;
            var data=this.temp;

            request({url: "/meterBill/save",method: "post",data}).then(data => {
              console.log(data,'data');
              if(data.code==200) {
                this.temp={}
                this.dialogVisible=false;
                this.dialogVisible2=true;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
                this.getList()
                var params={pkId: this.temped.pkid};
                request({url: "/meterBill/findMeterBillModeRecord",method: "get",params}).then(res => {
                  if(res.code==200) {
                    this.dataList2=res.data;
                    this.dialogVisible2=true;
                  }
                })
              } else {
                this.$message.error(`修改失败，${data.message}`);
              }
            })

          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';
        this.temp={
          'pkId': v.pkid,
          "id": v.id,
          "deductionStandard": v['单价'],
          "year": v['年'],
          "month": v['月'],
          "state": 1,
          "defaultType": 1,
          "name": v['计费名称'],
        }
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },


    }
  }
</script>

<style scoped lang="scss">
  .paginationed {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }

  .mytable {
    margin-top: 15px;
  }

  .myhistoryValue {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      // 正常
      .patrol {
        p {
          width: 8px;
          height: 8px;
          background-color: #0DAE88;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #0DAE88;
        }
      }

      // 非正常
      .rush {
        p {
          width: 8px;
          height: 8px;
          background-color: #FF1D1D;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #FF1D1D;
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }

      .tree-left {
        width: 300px;
        height: 100%;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;

        .btns {
          display: flex;
          // justify-content: space-evenly;
          margin-bottom: 8px;

          button {
            margin-right: 12px;
          }

          .el-button--mini {
            padding: 7px 10px !important;
          }

          .el-button+.el-button {
            margin-left: 0px;
          }
        }

        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 12px;
        }

      }

      .right-table {
        width: 100%;
        height: 100%;
        padding: 12px 20px 20px 20px;
        box-sizing: border-box;
        background-color: #fff;
        position: relative;

        .mycharts {
          display: flex;

          .charts-left {
            width: 35%;
          }

          .charts-right {
            width: 70%;
          }
        }
      }
    }
  }
</style>